import CandidateEducation from './CandidateEducation.container';

export default CandidateEducation;
